import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { photoFileAction, userFormAction, setChangeUserEmailFormAction } from "../../redux/rootReducer";
import { updateUserSagaAction } from "../../redux/sagaActions";
import { site } from "../../config";
import user_image from '../../assets/i/user.svg';
import TextareaAutosize from "react-textarea-autosize";
import { USER_FORM_INITIAL } from "../../redux/initialStateConstant";
import { AddNewUserThunk } from "../../redux/thunks/AddNewUserThunk";

// Ссылки на логотипы соцсетей
const vk = 'https://alga.by/fitness_images/social_networks_logos/vk.png';
const instagram = 'https://alga.by/fitness_images/social_networks_logos/instagram.png';
const youtube = 'https://alga.by/fitness_images/social_networks_logos/youtube.png';
const telegram = 'https://alga.by/fitness_images/social_networks_logos/telegram.png';

const UserForm = () => {
    const dispatch = useDispatch();
    const userForm = useSelector(state => state.userForm);
    const photo_file = useSelector(state => state.photo_file);
    const user = useSelector(state => state.user);

    const readFile = input => {
        // Ссылка на читаемый файл
        let file = input.target.files[0];

        // Создаём ссылку на FileReader
        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            dispatch(photoFileAction({ file, image: reader.result }));
        };
    };

    // Сохранение ссылки на логотип соц. сети
    const choiceSocialNetworkLogo = (network, index) => {
        // Копируем массив с сылками
        let links_copy = userForm.links.map(elem => {
            return { ...elem };
        });
        // Меняем значение в текущей ссылке
        links_copy[index].ico = network;

        // Сохраняем новое значение
        dispatch(userFormAction({
            ...userForm,
            links: links_copy
        }));

        setSocialNetworkIcoIndex(null);
    };

    // Индекс открытого дропдауна с выбором значка социальной сети
    const [socialNetworkIcoIndex, setSocialNetworkIcoIndex] = useState(null);

    if (!userForm.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__title">{ userForm.title }</div>
                        <i className="form__close" onClick={ () => {
                            dispatch(userFormAction(USER_FORM_INITIAL));
                            dispatch(photoFileAction(null));
                        } } />
                    </div>
                    {
                        user.slug === 'fitness'
                        ?
                            <div className="form__field">
                                <div
                                    style={{ color: 'red', font: '400 calc(14px - 1px)/18px Helvetica' }}
                                >Внимание! Вы находитесь в тестовой версии программы и авторизованы как гость. Все внесённые данные общедоступны.</div>
                            </div>
                        : false
                    }
                    <div className="form__field">
                        <label className="form__image-wrapper">
                            <input type="file" className="form__file" onChange={ file => readFile(file) } />
                            <div className="form__image"
                                 style={
                                     photo_file?.image
                                         ? { backgroundImage: `url(${ photo_file.image })`}
                                         : userForm.avatar
                                         ? { backgroundImage: `url(${ site + userForm.avatar })` }
                                         : { backgroundImage: `url(${ user_image })`, backgroundSize: `${ 38 }px` }
                                 }
                            />
                        </label>
                        {
                            (photo_file?.image) || userForm.avatar
                                ? <div className="form__image-remove"
                                       onClick={ () => {
                                           dispatch(userFormAction({
                                               ...userForm,
                                               avatar: ''
                                           }));
                                           dispatch(photoFileAction(null));
                                       } } >Удалить</div>
                                : false
                        }
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Имя и фамилия</div>
                        <input type="text" className="input" value={ userForm.name } onInput={ event => {
                            dispatch(userFormAction({
                                ...userForm,
                                name: event.target.value
                            }));
                        } }/>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Телефон</div>
                        <input type="text" className="input" value={ userForm.phone } onInput={ event => {
                            dispatch(userFormAction({
                                ...userForm,
                                phone: event.target.value
                            }));
                        } }/>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Почта</div>
                        {
                            userForm.id
                            ?
                                <div className="input input--inactive">{ userForm.email }</div>
                            :
                                <input type="text" className="input" value={ userForm.email } onInput={ event => {
                                    dispatch(userFormAction({
                                        ...userForm,
                                        email: event.target.value
                                    }));
                                } } />
                        }
                        <div className="link__add"
                            onClick={ () => {
                                // Закрываем форму редактирования пользователя
                                dispatch(userFormAction(USER_FORM_INITIAL));
                                // Открываем форму редактирования почты
                                dispatch(setChangeUserEmailFormAction({
                                    open: true,
                                    email: ''
                                }));
                            } }
                        >Сменить адрес почты</div>
                    </div>
                    {
                        userForm.date_registration
                        ?
                            <div className="form__field">
                                <div className="input__caption">Дата регистрации</div>
                                <div className="input input--inactive">{ userForm.date_registration }</div>
                            </div>
                        : false
                    }
                    <div className="form__field">
                        <div className="input__caption">Дата рождения в формате дд.мм.гггг</div>
                        <input type="text" className="input" value={ userForm.birthday } onInput={ event => {
                            dispatch(userFormAction({
                                ...userForm,
                                birthday: event.target.value
                            }));
                        } }/>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Пол</div>
                        <div className={ `radio ${ userForm.sex === 'male' ? 'radio--active' : '' }` } onClick={ () => {
                            dispatch(userFormAction({
                                ...userForm,
                                sex: 'male'
                            }));
                        } }>
                            <div className="radio__ico"/>
                            <div className="radio__title">Муж.</div>
                        </div>
                        <div className={ `radio ${ userForm.sex === 'female' ? 'radio--active' : '' }` } onClick={ () => {
                            dispatch(userFormAction({
                                ...userForm,
                                sex: 'female'
                            }));
                        } }>
                            <div className="radio__ico"/>
                            <div className="radio__title">Жен.</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Примечание</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ userForm.note }
                            onInput={ event => {
                                dispatch(userFormAction({
                                    ...userForm,
                                    note: event.target.value
                                }));
                            } }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Дополнительный идентификатор</div>
                        <input type="text" className="input" value={ userForm.additional_id } onInput={ event => {
                            dispatch(userFormAction({
                                ...userForm,
                                additional_id: event.target.value
                            }));
                        } }/>
                    </div>

                    <div className="form__field">
                        <div className="input__caption">Ссылки</div>
                        {
                            userForm.links.length
                                ?
                                userForm.links.map((elem, index) => {
                                    return (
                                        <div className="link__wrapper" key={ index }>
                                            <div className="link">
                                                <div className="link__ico input input--tick"
                                                     style={ elem.ico ? { backgroundImage: `url(${ elem.ico })` } : {} }
                                                     onClick={ () => setSocialNetworkIcoIndex(socialNetworkIcoIndex || socialNetworkIcoIndex === 0 ? null : index) }
                                                />
                                                <div className="dropdown link__ico-dropdown">
                                                    <div className={ `dropdown__items ${ socialNetworkIcoIndex === index ? 'dropdown__items--open ' : '' }` }>
                                                        <div className="dropdown__item link__ico-item"
                                                             onClick={ () => choiceSocialNetworkLogo('', index) }
                                                        />
                                                        <div className="dropdown__item link__ico-item"
                                                             style={{ backgroundImage: `url(${ vk })` }}
                                                             onClick={ () => choiceSocialNetworkLogo(vk, index) }
                                                        />
                                                        <div className="dropdown__item link__ico-item"
                                                             style={{ backgroundImage: `url(${ instagram })` }}
                                                             onClick={ () => choiceSocialNetworkLogo(instagram, index) }
                                                        />
                                                        <div className="dropdown__item  link__ico-item"
                                                             style={{ backgroundImage: `url(${ youtube })` }}
                                                             onClick={ () => choiceSocialNetworkLogo(youtube, index) }
                                                        />
                                                        <div className="dropdown__item  link__ico-item"
                                                             style={{ backgroundImage: `url(${ telegram })` }}
                                                             onClick={ () => choiceSocialNetworkLogo(telegram, index) }
                                                        />
                                                    </div>
                                                </div>
                                                <input type="text" className="input"
                                                       value={ elem.link }
                                                       onInput={ event => {
                                                           // Копируем массив с сылками
                                                           let links_copy = userForm.links.map(elem => {
                                                               return { ...elem };
                                                           });
                                                           // Меняем значение в текущей ссылке
                                                           links_copy[index].link = event.target.value;

                                                           // Сохраняем новое значение
                                                           dispatch(userFormAction({
                                                               ...userForm,
                                                               links: links_copy
                                                           }));
                                                       } }
                                                />
                                            </div>
                                            <div className="link__remove" onClick={ () => {
                                                // Подтверждение удаления ссылки
                                                if (!window.confirm('Вы действительно хотите удалить ссылку?')) return;

                                                // Копируем массив с сылками
                                                let links_copy = userForm.links.map(elem => {
                                                    return { ...elem };
                                                });
                                                // Удаляем выбранную ссылку
                                                links_copy.splice(index, 1);

                                                // Сохраняем новое значение
                                                dispatch(userFormAction({
                                                    ...userForm,
                                                    links: links_copy
                                                }));
                                            } }/>
                                        </div>
                                    );
                                })
                                : false
                        }
                        <div className="link__add" onClick={ () => {
                            // Копируем массив с сылками
                            let links_copy = userForm.links.map(elem => {
                                return { ...elem };
                            });
                            // Добавляем новую ссылку
                            links_copy.push({ ico: '', link: '' });

                            // Сохраняем новое значение
                            dispatch(userFormAction({
                                ...userForm,
                                links: links_copy
                            }));
                        } }>Добавить ссылку</div>
                    </div>

                    <div className="form__field">
                        <div className="button" onClick={ () => {
                            // Если есть id, редактируем посетителя
                            if (userForm.id) {
                                dispatch(updateUserSagaAction({
                                    id: userForm.id,
                                    name: userForm.name,
                                    phone: userForm.phone,
                                    email: userForm.email,
                                    avatar: photo_file || userForm.avatar,
                                    sex: userForm.sex,
                                    note: userForm.note,
                                    birthday: userForm.birthday,
                                    additional_id: userForm.additional_id,
                                    links: JSON.stringify(userForm.links)
                                }));
                            }
                            // Иначе, создаём нового
                            else {
                                dispatch(AddNewUserThunk({
                                    name: userForm.name,
                                    phone: userForm.phone,
                                    email: userForm.email,
                                    avatar: photo_file || userForm.avatar,
                                    sex: userForm.sex,
                                    note: userForm.note,
                                    birthday: userForm.birthday,
                                    additional_id: userForm.additional_id,
                                    links: JSON.stringify(userForm.links)
                                }));
                            }
                        } }>Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserForm;